import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-topic_select_page-view';
/**
 * Event that tracks when user views the &quot;Topic select&quot; page
 */
export function trackCxFoundationsTopicSelectPageView(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken },
    });
}
